import { render, staticRenderFns } from "./c-table-header.vue?vue&type=template&id=0635c021&scoped=true"
import script from "./c-table-header.vue?vue&type=script&lang=js"
export * from "./c-table-header.vue?vue&type=script&lang=js"
import style0 from "./c-table-header.vue?vue&type=style&index=0&id=0635c021&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0635c021",
  null
  
)

export default component.exports